import prototypes from "./prototypes";

export default class eHelpFramework {
    constructor(config) {
        this.debug = {
            reloadStylesheets: () => {
                var queryString = '?reload=' + new Date().getTime();
                document.querySelectorAll('link[rel="stylesheet"]').forEach(function (item) {
                    item.href = item.href.replace(/\?.*|$/, queryString);
                });
            },
            dataLayer: () => {
                if (window.dataLayer) {
                    let prompt = [];
                    window.dataLayer.forEach(item => {
                        for (let prop in item) {
                            if (!prop.match(/gtm|event/)) {
                                prompt[prop] = item[prop];
                            }
                        }
                    });
                    // console.log(prompt);
                    return prompt;
                } else {
                    console.log("No dataLayer has been found");
                }
            },
        }
        this.selector = config.selector;
        this.widgets = {
            push: obj => {
                try {
                    this.widgets[obj.constructor.name] = obj;
                    obj.parent = this;
                } catch (error) {
                    console.log(error);
                }

            }
        }
        this.pages = {
            push: obj => {
                try {
                    this.pages[obj.constructor.name] = obj;
                    obj.parent = this;
                } catch (error) {
                    console.log(error);
                }

            }
        }
        if (!window.eHelpFramework) {
            window.eHelpFramework = this;
        }

        document.ready().then(async () => {
            this.config = QelpCareHUB;
            this.init();
            if (config.datalayer == true) {
                this.initDataLayer();
            }
        });
    }
    async fetchData(url) {
        url = this.config.api + url;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async postData(url, data) {
        url = this.config.api + url;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }    
    getVersion () {
        return this.config.version;
    }
    call(endpoint, callback, method, formdata = null, auth = null) {
        var xhttp = new XMLHttpRequest();
        let data = null;
        if (method.toUpperCase() == "POST" && formdata != null) {
            data = new FormData();
            for (let prop in formdata) {
                data.append(prop, formdata[prop]);
            }
        }


        
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                if (xhttp.responseText) {
                    if (callback)
                        callback(JSON.parse(xhttp.responseText).data);
                }
            }
        };
        let url = "";
        if (endpoint.match(/(http:\/\/)|(https:\/\/)/)) {
            url = endpoint;
        } else {
            url = this.config.api + endpoint;
        }
        if (auth) {
            xhttp.setRequestHeader(auth.name, auth.key);
        }
        if (method=="POSTJSON") {
            xhttp.open("POST", url, true);
            xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhttp.send(JSON.stringify(formdata));
        } else {
            xhttp.open(method, url, true);
            xhttp.send(data);
        }
    }
    initDataLayer() {
        console.log("eHelpFramework:: initDataLayer");

        window._qelp_care__perc = 0;
        window.addEventListener("scroll", this.updateDataLayer);
        this.updateDataLayer();
        let ahrefs = document.querySelectorAll('a, button');

        for (var i = 0; i < ahrefs.length; i++) {
            let item = ahrefs[i];
            item.addEventListener("click", e => {
                let img = e.currentTarget.querySelector('img');
                let rsc = undefined;
                if (img) {
                    rsc = img.attributes.alt ? img.attributes.alt.value : null;
                } else {
                    rsc = e.currentTarget.innerHTML;
                }
                dataLayer.push({
                    "navigateTo": rsc,
                });
            });
        }
    }
    getRoot(url) {
        if (url) {
            return this.config.root + `${url}`;
        } else {
            return this.config.root;
        }
    }
    getRoute(label) {
        //translate routing
        let route = this.config.menu.find(item => {
            return item.translate == label;
        });
        return route.route;
    }
    updateDataLayer() {
        try {
            let footer = document.querySelector(".qelp-footer");
            if (!footer) return null;
            let perc = (window.pageYOffset + window.innerHeight) * 100 / footer.offsetTop;
            perc = perc - (perc % 10);

            if (perc > 100) perc = 100;

            if (perc > window._qelp_care__perc) {
                window._qelp_care__perc = perc
                dataLayer.push({
                    "scrollPercent": perc
                });
            }
        } catch (error) {
            console.log(error);
        }
    }
    init() {
        this.element = document.querySelector(this.selector);
        let dataobjs = document.querySelectorAll('[data-json].qc_embed_data');
        let _this = this;
        dataobjs.forEach(item => {
            _this[item.id.replace('data-', '')] = JSON.parse(item.dataset.json);
        });

        if (this.user_device && this.user_device.manufacturer) {
            this.orderlist('manufacturers', this.user_device.manufacturer);
            this.orderlist('devices', this.user_device.device);
        }


        let mainlogo = document.querySelector(".qc-topper .qc-logo");

        if (mainlogo) {
            mainlogo.addEventListener("click", e => {
                window.location = QelpCareHUB.root;
            });
        }
        this.initMainMenu();
        console.log("eHelpFramework:: eHelpFrameworkReady");
        let e = new Event("eHelpFrameworkReady");
        this.element.classList.remove("loading");

        if (this.config.clear_cache == true) {
            this.addParameter('clear_cache', true)
        }
        try {
            window.QelpCareHUB.selected = JSON.parse(document.querySelector("[name='qelpcarehub-data']").dataset.selected);
            window.QelpCareHUB.uri = window.location.pathname.substring(1);
        } catch (error) {
            console.log(error);
        }
        window.dispatchEvent(e);
    }
    addParameter(param_name, param_value) {
        var url = window.location.toString().split("?");
        let query = "?";
        var url_params;
        var params = [];
        params[param_name] = param_value;
        if (url.length>1) {
            url_params = url[1].split('&');
            url_params.forEach(item=>{
                let param = item.split("=");
                params[param[0]] = param[1] || null;
            });
        }

        for (var key in params) {
            if (query!="?") {
                query+= "&"
            };
            query += key + "=" + params[key];
        };
        // console.log(url, params);
        history.pushState({}, null, url[0] + query);
    }
    initMainMenu() {
        this.menu_i_element = document.querySelector(".qc-topper .menu-icon");

        if (this.menu_i_element) {
            this.menu_i_element.addEventListener("click", e => {
                this.toogleMainMenu();
            });
        }
       
    }
    toogleMainMenu() {
        this.menu_element = document.querySelector(".qc-topper .qc-side-menu");
        this.menu_icons = document.querySelectorAll(".qc-topper .menu-icon i").forEach(elem => {
            elem.classList.toggle("hidden");
        });
        document.body.classList.toggle("scroll-locked");
        this.menu_element.classList.toggle("active");
        document.querySelector(".qc-topper.qc-widget").classList.toggle("menu-open");
    }
    orderlist(list, listby) {
        let selector = `.qelp-care-ul.${list}`;
        document.querySelectorAll(selector).forEach(ul => {
            ul.childNodes.forEach(item => {
                try {
                    if (item.dataset.name.match(RegExp(listby))) {
                        item.style.order = "1";
                    }
                } catch (error) {

                }
            })
        })
    }
}